import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { fetchInstructorCourses } from '../../../../services/operations/courseDetailsAPI';
import IconBtn from '../../../common/IconBtn';
import { VscAdd } from 'react-icons/vsc';
import CoursesTable from './CoursesTable';

const MyCourses = () => {
    const {token} = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);

    

    useEffect(()=>{
        const fetchCourses = async() =>{
            setLoading(true);
            const result = await fetchInstructorCourses(token);
            if(result){
                setCourses(result);
            }
            setLoading(false);
        }
        fetchCourses();
    }, []);
  return (
    <div>
        <div className="mb-14 flex items-center justify-between">
            <h1 className="text-3xl font-medium text-richblack-5">My Courses</h1>
            <IconBtn text={"Add Course"} onClick={()=> navigate("/dashboard/add-course")}>
                <VscAdd />
            </IconBtn>
        </div>
        {
            loading ? (
                <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
                    <div className="spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : (
                
                courses.length === 0 ? (
                    <p className="grid h-[10vh] w-full place-content-center text-richblack-5">
                        You have not created any course yet.
                    </p>
                ) : (
                    <CoursesTable courses={courses} setCourses={setCourses}/>
                )
            )
        }
    </div>
  )
}

export default MyCourses
